const getTextFromChildren = children => {
  if (!children) return '';
  if (typeof children === 'string' || typeof children === 'number') return `${children}`;
  if (Array.isArray(children)) {
    return children.map(child => `${getTextFromChildren(child)}`).filter(Boolean).join(' ');
  }
  if (!children.props) return '';
  if (children.props.children) return `${getTextFromChildren(children.props.children)}`;
  const {
    props: {
      altText,
      name: _name,
      title,
      ariaLabel
    }
  } = children;
  return altText || _name || title || ariaLabel || '';
};
export default getTextFromChildren;
//# sourceMappingURL=get-text-from-children.js.map